import * as React from "react";
import { MensMenu } from "../../components/pageComponents/Menus/MensMenu";
import Content from "./Shirts";

export default function MensContent() {
  return (
    <>
      <MensMenu />
      <Content />
    </>
  );
}
